var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2742 8.0615C11.2789 8.31243 11.1549 8.5568 10.9238 8.75219L3.17442 15.2686C2.91135 15.4904 2.53057 15.6319 2.11584 15.6619C1.7011 15.6919 1.28639 15.608 0.962942 15.4287C0.639488 15.2493 0.433786 14.9892 0.391086 14.7056C0.348386 14.4219 0.472186 14.138 0.735253 13.9162L7.67901 8.09467L0.807075 2.40064C0.674952 2.29198 0.575595 2.16647 0.514715 2.03133C0.453834 1.89618 0.432631 1.75406 0.452322 1.61314C0.472014 1.47221 0.532212 1.33526 0.629457 1.21015C0.726703 1.08504 0.859079 0.974244 1.01898 0.884126C1.17887 0.78428 1.36709 0.708041 1.57184 0.660186C1.77659 0.612331 1.99346 0.593892 2.20887 0.606022C2.42427 0.618152 2.63357 0.660589 2.82364 0.730678C3.01372 0.800767 3.18047 0.896996 3.31347 1.01334L10.9968 7.38734C11.1969 7.58431 11.2946 7.82167 11.2742 8.0615Z",
    fill: "#0A490A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCaret);
export default __webpack_public_path__ + "static/media/left-caret.a5345022326420b9a47e24c1138cfdfd.svg";
export { ForwardRef as ReactComponent };